// Importació de vistes
const Home = () => import("../views/home/Home.vue");
const LightTackle = () => import("../views/activities/LightTackle.vue");
const BottomFishing = () => import("../views/activities/BottomFishing.vue");
const AmberjackFishing = () =>
  import("../views/activities/AmberjackFishing.vue");
const DentexFishing = () => import("../views/activities/DentexFishing.vue");
const GiantBluefinTuna = () =>
  import("../views/activities/GiantBluefinTuna.vue");
const DeepSeaTrolling = () => import("../views/activities/DeepSeaTrolling.vue");
const PrivateBoat = () => import("../views/activities/PrivateBoat.vue");
const Contact = () => import("../views/Contact.vue");
const NotFound = () => import("../views/NotFound.vue");

const routeConfigs = {
  Home: {
    component: Home,
    paths: {
      es: "/",
      en: "/en",
    },
    meta: {
      es: {
        title: "Charters de Pesca en Mallorca | Los Mejores Tours de Pesca",
        metaDesc:
          "Descubre con Enigma los mejores Tours y Charters de pesca en Mallorca. Disfruta de nuestros charters privados de pesca. Contactanos",
        keyword: "Charters de Pesca en Mallorca",
      },
      en: {
        title: "Fishing Charters in Mallorca | The Best Mallorca Fishing Tours",
        metaDesc:
          "Discover with Enigma the best Fishing Tours and Charters in Mallorca. Enjoy our private fishing charters in the norh of Mallorca. Contact us",
        keyword: "mallorca fishing charters",
      },
    },
  },
  LightTackle: {
    component: LightTackle,
    paths: {
      es: "/charter-pesca-cana-mallorca",
      en: "/en/light-tackle-mallorca-charter",
    },
    meta: {
      es: {
        title: "Charter de Pesca con caña ligera en Mallorca | Enigma Charters",
        metaDesc:
          "Pesca muy popular en Mallorca y totalmente recomendable para iniciarse. Charter para los más pequeños o adultos sin gran presupuesto.",
        keyword: "Charter pesca con caña ligera en Mallorca",
        schemaName: "Charter de Pesca con Caña Ligera en Mallorca",
        schemaDesc:
          "Charter privado de pesca con caña ligera en Mallorca. Una experiencia de 3 horas para familias, niños y principiantes, disponible todo el año y guiada por un patrón profesional.",
      },
      en: {
        title: "Light tackle fishing charter in Mallorca | Enigma Charters",
        metaDesc:
          "Very popular fishing in Mallorca and highly recommended for beginners. Charter for children or adults without a big budget.",
        keyword: "Light tackle fishing charter in Mallorca",
        schemaName: "Light Tackle Fishing Charter in Mallorca",
        schemaDesc:
          "Private light tackle fishing charter in Mallorca. A 3-hour fishing experience for families, children and beginners, available all year round and guided by a professional skipper.",
      },
    },
  },
  BottomFishing: {
    component: BottomFishing,
    paths: {
      es: "/charter-currican-costero-pesca-fondo-mallorca",
      en: "/en/bottom-fishing-charter-mallorca",
    },
    meta: {
      es: {
        title: "Charter Curricán Costero o Pesca de Fondo en Mallorca | Enigma",
        metaDesc:
          "Navegaremos a 3-5 nudos arrastrando unos señuelos en el agua en busca de dorados, llampuga, barracuda, bonito, serviolas, etc.",
        keyword: "charter pesca de fondo en mallorca",
        schemaName: "Charter de Curricán Costero o Pesca de Fondo en Mallorca",
        schemaDesc:
          "Charter privado y compartido de curricán costero o pesca de fondo en Mallorca. Una experiencia de pesca fácil de 4 horas disponible todo el año, en busca de especies mediterráneas con guía profesional.",
      },
      en: {
        title:
          "Inshore Trolling or Bottom Fishing Charter in Mallorca | Enigma",
        metaDesc:
          "We will sail at 3-5 knots dragging lures in the water in search of dorado, dolphinfish, barracuda, bonito, amberjack, etc",
        keyword: "bottom fishing charter in mallorca",
        schemaName: "Inshore Trolling or Bottom Fishing Charter in Mallorca",
        schemaDesc:
          "Private and shared inshore trolling or bottom fishing charter in Mallorca. A 4-hour easy fishing experience available all year round, targeting Mediterranean species with professional guidance.",
      },
    },
  },
  AmberjackFishing: {
    component: AmberjackFishing,
    paths: {
      es: "/charter-pesca-serviola-mallorca",
      en: "/en/amberjack-fishing-charter-mallorca",
    },
    meta: {
      es: {
        title:
          "Charter Pesca de Serviola en Mallorca | Enigma Fishing Charters",
        metaDesc:
          "Charter de pesca con cebo vivo en busca de la serviola. Pesca divertida y con un componente importante de adrenalina sin requerir experiencia.",
        keyword: "Charter Pesca de Serviola en Mallorca",
        schemaName: "Charter de Pesca de Serviola en Mallorca",
        schemaDesc:
          "Charter privado de pesca de serviola en Mallorca. Una experiencia de pesca de nivel medio de 8 horas disponible de agosto a octubre, en busca de la poderosa serviola con guía profesional.",
      },
      en: {
        title:
          "Amberjack Fishing Charter in Mallorca | Enigma Fishing Charters",
        metaDesc:
          "Live bait fishing charter in search of amberjack. Fun fishing with an important adrenaline component and no experience required.",
        keyword: "Amberjack Fishing Charter in Mallorca",
        schemaName: "Amberjack Fishing Charter in Mallorca",
        schemaDesc:
          "Private amberjack fishing charter in Mallorca. An 8-hour medium-level fishing experience available from August to October, targeting powerful amberjack with professional guidance.",
      },
    },
  },
  DentexFishing: {
    component: DentexFishing,
    paths: {
      es: "/charter-pesca-denton-mallorca",
      en: "/en/dentex-fishing-charter-mallorca",
    },
    meta: {
      es: {
        title: "Charter Pesca de Calamar y Dentón en Mallorca | Enigma Fishing",
        metaDesc:
          "Charter en temporada baja para capturar calamares que nos servirán de cebo para en aguas más profundas pescar dentón en Mallorca.",
        keyword: "Charter Pesca de Dentón en Mallorca",
        schemaName: "Charter de Pesca de Calamar y Dentón en Mallorca",
        schemaDesc:
          "Charter privado de pesca de calamar y dentón en Mallorca. Una experiencia de pesca de nivel medio de 7 horas disponible de noviembre a abril, en busca del dentón y otros depredadores mediterráneos con guía profesional.",
      },
      en: {
        title: "Squid and Dentex Fishing Charter in Mallorca | Enigma Fishing",
        metaDesc:
          "Fishing charter in low season to catch squid that will serve as bait for fishing for dentex in deeper waters in Mallorca.",
        keyword: "Dentex Fishing Charter in Mallorca",
        schemaName: "Squid and Dentex Fishing Charter in Mallorca",
        schemaDesc:
          "Private squid and dentex fishing charter in Mallorca. A 7-hour medium-level fishing experience available from November to April, targeting dentex and other Mediterranean predators with professional guidance.",
      },
    },
  },
  GiantBluefinTuna: {
    component: GiantBluefinTuna,
    paths: {
      es: "/charter-atun-rojo-gigante-mallorca",
      en: "/en/giant-bluefin-tuna-fishing",
    },
    meta: {
      es: {
        title: "Charter Pesca del Atún Rojo Gigante en Mallorca | Enigma Tours",
        metaDesc:
          "Vive la emoción única de luchar contra uno de los peces más poderosos del océano en el mejor lugar del mediterráneo. Contáctanos",
        keyword: "Charter Atún Rojo Gigante Mallorca",
        schemaName: "Charter de Pesca del Atún Rojo Gigante en Mallorca",
        schemaDesc:
          "Charter privado de pesca del atún rojo gigante en Mallorca. Una experiencia de pesca de nivel medio de 8 horas disponible todo el año, en busca del atún rojo gigante con guía profesional y práctica de captura y suelta.",
      },
      en: {
        title: "Giant Bluefin Tuna Fishing Charter in Mallorca | Enigma Tours",
        metaDesc:
          "Experience the unique thrill of fighting one of the most powerful fish in the ocean in the best place in the Mediterranean. Contact us",
        keyword: "Giant Bluefin Tuna Fishing Charter in Mallorca",
        schemaName: "Giant Bluefin Tuna Fishing Charter in Mallorca",
        schemaDesc:
          "Private giant bluefin tuna fishing charter in Mallorca. An 8-hour medium-level fishing experience available all year round, targeting giant bluefin tuna with professional guidance and catch-and-release practices.",
      },
    },
  },
  DeepSeaTrolling: {
    component: DeepSeaTrolling,
    paths: {
      es: "/charter-currican-altura-mallorca",
      en: "/en/deep-sea-trolling-charter-mallorca",
    },
    meta: {
      es: {
        title: "Charter Pesca Curricán de Altura en Mallorca | Enigma Charters",
        metaDesc:
          "Charter de 7 ó 9 horas para la pesca de la aguja imperial o bonito del norte. Aventura de pesca en alta mar para pescadores experimentados",
        keyword: "Charter Curricán de Altura en Mallorca",
        schemaName: "Charter de Curricán de Altura en Mallorca",
        schemaDesc:
          "Charter privado de curricán de altura en Mallorca. Salidas de pesca en alta mar disponibles de mayo a septiembre en busca de atún rojo, bonito del norte, dorado, bonito y aguja blanca con guía profesional.",
      },
      en: {
        title: "Deep Sea Trolling Charter in Mallorca | Enigma Charters",
        metaDesc:
          "Charter of 7 or 9 hours for fishing for imperial marlin or white tuna. Deep sea trolling fishing adventure just for experienced anglers.",
        keyword: "Deep Sea Trolling Charter in Mallorca",
        schemaName: "Deep Sea Trolling Charter in Mallorca",
        schemaDesc:
          "Private deep sea trolling charter in Mallorca. Offshore fishing trips available from May to September targeting bluefin tuna, albacore, dorado, bonito and white marlin with professional guidance.",
      },
    },
  },
  PrivateBoat: {
    component: PrivateBoat,
    paths: {
      es: "/paseo-en-barco-snorkel-mallorca",
      en: "/en/private-boat-tour-snorkel-mallorca",
    },
    meta: {
      es: {
        title: "Paseo en Barco Privado, Snorkel y Sunset en Mallorca | Enigma Charter",
        metaDesc:
          "Descubre calas vírgenes con el Capitán Tomeu Geneta. Paseos en barco a medida hasta 11 plazas, snorkel, ancla virtual, tapas y atardeceres. Reserva ahora.",
        keyword: "Paseo en Barco Privado Snorkel en Mallorca",
      },
      en: {
        title: "Private Boat Tour, Snorkel & Sunset in Mallorca | Enigma Charter",
        metaDesc:
          "Discover hidden coves with Captain Tom Geneta. Custom private boat tours up to 11 pax, snorkeling, virtual anchor, tapas & sunsets. Book now.",
        keyword: "Private Boat Tour Snorkel Sunset in Mallorca",
      },
    },
  },
  Contact: {
    component: Contact,
    paths: {
      es: "/enigma-fishing-charter",
      en: "/en/enigma-fishing-charter",
    },
    meta: {
      es: {
        title:
          "Enigma Fishing Charter | Los mejores Charters de Pesca en Mallorca",
        metaDesc:
          "Enigma Fishing Charter Mallorca, tu destino ideal para vivir aventuras de pesca exclusivas en las impresionantes aguas del Mediterráneo",
        keyword: "enigma fishing charter",
      },
      en: {
        title: "Enigma Fishing Charter | Best Fishing Charters in Mallorca",
        metaDesc:
          "Enigma Fishing Charter Mallorca, your ideal destination for exclusive fishing adventures in the stunning waters of the Mediterranean.",
        keyword: "enigma fishing charter",
      },
    },
  },
};

// Generar rutes automàticament
function generateLocalizedRoutes() {
  const routes = [];

  Object.entries(routeConfigs).forEach(([name, config]) => {
    ["es", "en"].forEach((lang) => {
      const route = {
        path: config.paths[lang],
        name: `${name}${lang.toUpperCase()}`,
        component: config.component,
        meta: {
          lang,
          ...config.meta[lang],
        },
      };

      routes.push(route);
    });
  });

  return routes;
}

export const routes = [
  ...generateLocalizedRoutes(),
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: NotFound,
  },
];
